import {useTranslation} from "react-i18next";
import OrderByHeaders from "components/ordering/OrderByHeaders";

const TableIncidences = ({itemsShow, items, checkAll, setCheckAll, buttonsTB, setButtonsTB, orderingRef, ChoicesReason, ChoicesStatus}) => {
    const {t: _Tc} = useTranslation("choices");

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }
        const itemId = Number(e.currentTarget.dataset.idx);

        if (checkbox.checked) {
            items.current.addToChosen(itemId);
        } else {
            items.current.removeFromChosen(itemId);
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => Number(item.id));
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.edit.disabled = items.current.chosen.length !== 1;
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "168px",
        backgroundColor: "white",
    };

    return (
        <table className="table table-striped table-sticky-horizontal">
            <thead>
                <tr>
                    <th style={{...stickyHeaderStyle}} key="-1">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} styleHeaders={stickyHeaderStyle} />
                </tr>
            </thead>
            <tbody>
                {itemsShow.length ? (
                    itemsShow.map((item) => (
                        <tr key={item.id} data-idx={item.id} onClick={onClick}>
                            <td>
                                <input
                                    type="checkbox"
                                    name="checkboxIncidence"
                                    key={item.id}
                                    data-idx={item.id}
                                    defaultChecked={Array.isArray(items.current.chosen) ? items.current.chosen.includes(item.id) : false}
                                    readOnly={true}
                                />
                            </td>
                            <td>{item.name}</td>
                            <td>{item.description}</td>
                            <td>{ChoicesReason[item.reason] || item.reason}</td>
                            <td>{ChoicesStatus[item.status] || item.status}</td>
                            <td>{item.created_by__email || '-'}</td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={8}></td>
                    </tr>
                )}
            </tbody>
        </table>
    );
};

export default TableIncidences;
